module.exports = __webpack_public_path__ + "static/media/wheel-elipse.0224fbd4.svg";